import { forwardRef } from 'react';
import { InputBase as MuiInputBase } from '@mui/material';
import { InputBaseProps } from './Input';
import { readFiles, inputFilesValidators } from './utils';

interface FileInputProps extends Omit<InputBaseProps, 'error'> {
  handleChangeFiles?: (images: any, files: any) => void;
  withoutCompress?: boolean;
}

const FileInputInner = (
  {
    label = '',
    id = '',
    handleChangeFiles,
    withoutCompress,
    ...props
  }: FileInputProps,
  ref: React.ForwardedRef<HTMLInputElement>,
) => {
  const handleOnChange = (e: any) => {
    readFiles(
      e,
      (readedFiles, files) => {
        if (!inputFilesValidators(readedFiles, files)) return;

        handleChangeFiles && handleChangeFiles(readedFiles, files);
      },
      withoutCompress,
    );
  };

  return (
    <MuiInputBase
      id={id || label}
      data-size={'medium'}
      type={'file'}
      onChange={handleOnChange}
      inputRef={ref}
      inputProps={{
        value: props.value,
      }}
      value={undefined}
      {...props}
    />
  );
};

export const FileInput = forwardRef<HTMLInputElement, FileInputProps>(
  FileInputInner,
) as React.ComponentType<FileInputProps>;
FileInput.displayName = 'FileInput';
